var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c("b-input", {
                attrs: { type: "password", placeholder: "Aktuelles Passwort" },
                model: {
                  value: _vm.passwordOld,
                  callback: function($$v) {
                    _vm.passwordOld = $$v
                  },
                  expression: "passwordOld"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Password", {
        ref: "password",
        attrs: {
          placeholder1: "Neues Passwort",
          placeholder2: "Neues Passwort (wiederholen)"
        },
        model: {
          value: _vm.passwordNew,
          callback: function($$v) {
            _vm.passwordNew = $$v
          },
          expression: "passwordNew"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right mt-4" },
        [
          _c("Button", {
            attrs: {
              text: "Passwort ändern",
              disabled: !_vm.dataValid || _vm.changing,
              loading: _vm.changing,
              icon: "checkmark"
            },
            on: { click: _vm.change }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }